import React, { useState } from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { PlaylistAdd } from '@material-ui/icons';
import BundleEditDialog from './BundleEditDialog';
import { dialogContexts } from '../../../../constants/constants';

const BundleCreate = () => {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <ListItem button onClick={() => setOpenDialog(true)}>
        <ListItemIcon>
          <PlaylistAdd />
        </ListItemIcon>
        <ListItemText
          primary='Create new bundle'
          primaryTypographyProps={{ color: 'textSecondary', variant: 'button' }}
        />
      </ListItem>
      <BundleEditDialog
        dialogContext={dialogContexts.CREATE}
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
      />
    </>
  );
};

export default BundleCreate;
